export default {
    approvalStatus: {
        pending: 'PENDING',
        approved: 'APPROVED',
        rejected: 'REJECTED',
    },
    pushStatus: {
        pending: 'PENDING',
        completed: 'COMPLETED',
        failed: 'FAILED',
    },
    testingStatus: {
        pending: 'PENDING',
        approved: 'APPROVED',
        rejected: 'REJECTED',
    },
}
